import PropTypes from 'prop-types'

const TableFour = (props: any) => {
    return (
        <ul className='table-four'>
            {props.elements.map((item: any, i: number) => (
                <li key={i}>
                    <span> {item.first} </span>
                    <span> {item.second} </span>
                    <span> {item.third} </span>
                    <span> {item.fourth} </span>
                </li>
            ))}
        </ul>
    )
}

export default TableFour

TableFour.propTypes = {
    elements: PropTypes.array.isRequired
}
